import React, { useState } from 'react'
import i18n from '~/i18n'

const EXAMPLE_GROUPS = [
    {
        titleKey: 'mcp:examples.groups.contacts',
        prompts: [
            'mcp:examples.prompts.countContacts',
            'mcp:examples.prompts.lookupContact',
            'mcp:examples.prompts.findGroup',
            'mcp:examples.prompts.createSegment'
        ]
    },
    {
        titleKey: 'mcp:examples.groups.campaigns',
        prompts: [
            'mcp:examples.prompts.campaignStats',
            'mcp:examples.prompts.campaignTrends',
            'mcp:examples.prompts.whoClicked',
            'mcp:examples.prompts.draftCampaign'
        ]
    },
    {
        titleKey: 'mcp:examples.groups.automations',
        prompts: [
            'mcp:examples.prompts.listAutomations',
            'mcp:examples.prompts.explainAutomation',
            'mcp:examples.prompts.enrollContact',
            'mcp:examples.prompts.createAutomation'
        ]
    },
    {
        titleKey: 'mcp:examples.groups.site',
        prompts: [
            'mcp:examples.prompts.recentVisitors',
            'mcp:examples.prompts.contactActivity',
            'mcp:examples.prompts.siteEvents'
        ]
    },
    {
        titleKey: 'mcp:examples.groups.deliverability',
        prompts: [
            'mcp:examples.prompts.improveDeliverability',
            'mcp:examples.prompts.sendingDomains',
            'mcp:examples.prompts.spamTest'
        ]
    },
    {
        titleKey: 'mcp:examples.groups.social',
        prompts: ['mcp:examples.prompts.socialStats', 'mcp:examples.prompts.draftSocial']
    }
]

export default function ExamplePrompts() {
    const [copiedKey, setCopiedKey] = useState(null)

    async function copyPrompt(key, text) {
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(text)
            }
            setCopiedKey(key)
            setTimeout(() => setCopiedKey(null), 1600)
        } catch (err) {
            // ignore
        }
    }

    return (
        <div className='mcp-examples'>
            <div className='mcp-examples__heading'>
                <div className='mcp-examples__label'>{i18n.t('mcp:examples.label')}</div>
                <p className='mcp-examples__hint'>{i18n.t('mcp:examples.hint')}</p>
            </div>
            <div className='mcp-examples__groups'>
                {EXAMPLE_GROUPS.map((group) => (
                    <div className='mcp-examples__group' key={group.titleKey}>
                        <div className='mcp-examples__group-title'>{i18n.t(group.titleKey)}</div>
                        <div className='mcp-examples__list'>
                            {group.prompts.map((key) => {
                                const text = i18n.t(key)
                                return (
                                    <button
                                        key={key}
                                        type='button'
                                        className='mcp-examples__chip'
                                        onClick={() => copyPrompt(key, text)}
                                        title={i18n.t('mcp:instructions.copy')}
                                    >
                                        {copiedKey === key ? i18n.t('mcp:instructions.copied') : text}
                                    </button>
                                )
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
